<!--
 * @Author: cnb zhangguoxin19@crpcg.com
 * @Date: 2026-04-23 22:25:06
 * @LastEditors: cnb zhangguoxin19@crpcg.com
 * @LastEditTime: 2026-04-23 23:42:08
 * @FilePath: /survey_frontend/src/view/infopanel.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
 <template>
  <div class="weui-cells">
    <a class="weui-cell weui-cell_access" href="javascript:;" @click="handleRegister">
      <div class="weui-cell__bd">
        <p>注册及填写信息，仅限首次</p>
      </div>
      <div class="weui-cell__ft">
        <i class="icon icon-public-right"></i>
      </div>
    </a>
    <a class="weui-cell weui-cell_access" @click="handleEdit">
      <div class="weui-cell__bd">
        <p>编辑信息</p>
      </div>
      <div class="weui-cell__ft">
        <i class="icon icon-public-right"></i>
      </div>
    </a>
    <a class="weui-cell weui-cell_access" href="javascript:;" @click="handleSurvey">
      <div class="weui-cell__bd">
        <p>去答题</p>
      </div>
      <div class="weui-cell__ft">
        <i class="icon icon-public-right"></i>
      </div>
    </a>
  </div>
</template>
<script>
import { getInfopanelLinks } from '../api/index'
export default {
  name: 'infopanel',
  data() {
    return {
      editAttributeUrl: '',
      surveyListUrl: ''
    }
  },
  methods: {
    // 提交用户信息
    async doGetInfopanelLinks () {
      let params = {
        param: {
        }
      }
      let res = {}
      try {
        res = await getInfopanelLinks(params)
        this.$toast.loading('加载中', { duration: 0 });
        if (res.code === '0000') {
          this.editAttributeUrl = res.result.editAttributeUrl
          this.surveyListUrl = res.result.surveyListUrl
          this.$toast.hide()
          // this.$toast.success('获取成功')
        } else {
          this.$toast.error(res.message)
        }
      } catch (err) {
        this.$toast.error(err.message)
      }
    },
    // 注册及填写信息
    handleRegister() {
      // 这里可以添加注册逻辑或跳转到注册页面
      location.href = this.surveyListUrl
    },
    // 编辑信息
    handleEdit() {
      location.href = this.editAttributeUrl
    },
    // 去答题
    handleSurvey() {
      location.href = this.surveyListUrl
    }
  },
  mounted () {
    this.doGetInfopanelLinks()
  }
}
</script>
<style lang="css" scoped>
.weui-cells {
  background-color: #ffffff;
}
.weui-cell {
  background-color: #ffffff;
}
</style>
